import type { ActionState } from './ActionState';

export const actionProps = {
  /**
   * What state is the action in.
   */
  state: {
    type: String as PropType<ActionState>,
    required: false,
    default: '',
  },
  /**
   * Defines a title for accessibility will be shown when
   * hovering the element
   */
  title: {
    type: String,
    required: false,
  },
  /**
   * Should the button take focus on mount?
   */
  autofocus: {
    type: Boolean,
    required: false,
    default: false,
  },
  /**
   * Useful for selecting the element under end to end
   * testing give any string based unique id
   */
  testId: {
    type: String,
    required: false,
    default: undefined,
  },
};
